import React, { Component } from "react";
import { connect } from 'react-redux';
import "./Footer.scss"
import i18n from "@/i18n"
import { GetWordpressUrl } from "@/utils/Global";
class Cafe24Footer extends Component{
      handleClickFooterMenu = movePath => {
        this.props.history.push(`${movePath}?date=cafe24`);
      }
      
      handleMoveSocialPage = movePath => {
        window.open(movePath, '_blank')
      }
    
      handleClickArrow = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      }
    
      handleClickFaQ = () => {
        const url = GetWordpressUrl({ type: "faq", lang: "ko" });
        window.open(url, '_blank')
      }

      handleClickLink = (name) => {
        let { lang } = this.props
    
        const url = GetWordpressUrl({ type: name, lang });
        window.open(url, '_blank')
      }
      
    render(){
        return (
            <div className="footer-root-container">
                <div className="navigator-root">
                    <div className="navigator-wrapper">
                        <div className='spacer' />
                        <div className="navigator">
                            <div className="navigator">
                                <div className="nav-item" onClick={() => this.handleClickFooterMenu('/Tos')}>{i18n.t("footer.tos.link")}</div>
                                <div className="nav-item" onClick={() => this.handleClickFooterMenu('/Privacy')}>{i18n.t("footer.privacy.link")}</div>
                                <div className="nav-item" onClick={() => this.handleClickFooterMenu('/Copyright')}>{i18n.t("footer.copyright.link")}</div>
								<div className="nav-item" onClick={() => this.handleClickFooterMenu('/ai-product-term')}>{i18n.t("footer.ai.link")}</div>
                                <div className="nav-item" onClick={() => this.handleClickLink('tutorial')}>{i18n.t("navigator.menu.tutorial")}</div>
                                <div className="nav-item" onClick={this.handleClickFaQ}>{i18n.t("navigator.menu.faq")}</div>
                                <div className="nav-item" onClick={() => window.location.href = 'mailto:support@videomonster.com'}>Contact</div>
                            </div>
                        </div>
                        <div className="manual-download">
                            <a href={`/pdf/videomonster_manual_${this.props.lang}.pdf`} download>
                                <button>
                                    <img src="https://front.videomonster.com/images-u6yd72dy/web/pdf_download_icon.svg" alt={""} />
                                    <span>{i18n.t("navigator.user.guide.download")}</span>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
  })

  export default connect(mapStateToProps, null)(Cafe24Footer)